/* esm.sh - applesauce-relay@5.2.0/dist/operators/mark-from-relay */
import{tap as p}from"rxjs";import{addSeenRelay as e}from"applesauce-core/helpers";function m(o){return t=>t.pipe(p(r=>{typeof r!="string"&&e(r,o)}))}export{m as markFromRelay};
//# sourceMappingURL=mark-from-relay.mjs.map